import './color-hsl.css';

export default {};
